import React from 'react';
import Select, { StylesConfig } from 'react-select';

export interface SelectOption {
  value: string;
  label: string;
}

export const selectStyles: StylesConfig<SelectOption, boolean> = {
  control: (base, state) => ({
    ...base,
    minHeight: '40px',
    borderRadius: '10px',
    borderColor: state.isFocused ? '#292a2b' : '#e6e8ec',
    boxShadow: 'none',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    '&:hover': { borderColor: '#292a2b' }
  }),
  valueContainer: (base) => ({ ...base, padding: '0 12px' }),
  singleValue: (base) => ({ ...base, fontSize: '13px', color: '#292a2b' }),
  multiValue: (base) => ({ ...base, borderRadius: '8px', backgroundColor: '#faf8f6' }),
  multiValueLabel: (base) => ({ ...base, fontSize: '13px', color: '#292a2b' }),
  placeholder: (base) => ({ ...base, fontSize: '13px' }),
  input: (base) => ({ ...base, fontSize: '13px' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 10px 0 4px', color: '#707071' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({
    ...base,
    marginTop: '6px',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid #e6e8ec',
    boxShadow: '0px 2px 6px 2px rgba(0,0,0,0.08)'
  }),
  menuList: (base) => ({ ...base, padding: '6px' }),
  option: (base, state) => ({
    ...base,
    borderRadius: '8px',
    fontSize: '13px',
    fontFamily: state.isSelected ? 'Gilroy-Medium' : 'Gilroy-Regular',
    color: '#292a2b',
    backgroundColor: state.isSelected ? '#f8f4f1' : state.isFocused ? '#faf8f6' : 'transparent',
    cursor: 'pointer'
  })
};

export const toOptions = (values: string[], empty?: string): SelectOption[] =>
  values.map((v) => ({ value: v, label: v || empty || '—' }));

export const RequestSelect: React.FC<{
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  placeholder?: string;
  searchable?: boolean;
  ariaLabel?: string;
}> = ({ value, options, onChange, placeholder, searchable, ariaLabel }) => (
  <Select<SelectOption, false>
    aria-label={ariaLabel}
    value={options.find((o) => o.value === value) ?? null}
    options={options}
    placeholder={placeholder}
    isSearchable={!!searchable}
    menuPortalTarget={document.body}
    menuPlacement="auto"
    styles={selectStyles}
    onChange={(selected) => onChange(selected?.value ?? '')}
  />
);
